import ChangeEntityDialog from './ChangeEntityDialog';

export default ChangeEntityDialog;
